import(/* webpackMode: "eager" */ "/opt/buildhome/repo/fronted/app/page.tsx");
